import { render, staticRenderFns } from "./CourseDemoList.vue?vue&type=template&id=f18e34ec&class=course-list-demo&style=padding-bottom%3A%2020px&"
import script from "./CourseDemoList.vue?vue&type=script&lang=js&"
export * from "./CourseDemoList.vue?vue&type=script&lang=js&"
import style0 from "./CourseDemoList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports